import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import slugify from 'underscore.string/slugify';

import t from '../../lib/I18n';
import Assets from '../../helpers/Assets';
import StoredPaymentCard from '../../records/customer/StoredPaymentCard';
import CardPayment from '../../records/order/CardPayment';
import HostedCardPayment from '../../records/order/HostedCardPayment';

function PaymentCardDetails ({ card, className, highDefinition, showExpires, mask }) {

    const { pan, expiryDate, cardArtUrl } = card;
    const cardType = card.cardType || '';

    const cardTypeSlug = slugify(cardType.toLowerCase());

    let highDefArtUrl = ['mc-credit', 'mc-debit', 'visa-credit', 'visa-debit', 'amex'].includes(cardTypeSlug);

    const cardClassNames = classnames(!highDefinition ? 'pan' : 'pan-hd', !cardArtUrl && !highDefinition ? `card-${cardTypeSlug}` : '', className);
    const visaCheckoutCardArt = (<img className="visacheckout-cart-art" src={ cardArtUrl } alt={ cardType }/>);
    const highDefImageArt = highDefArtUrl ? (<img className="pan-hd__image" src={ Assets.assetUrl(`images/card-hd-${cardTypeSlug}.png`) } alt={ cardType }/>) : null;
    const cardExpiryDate = (<p> { t('paymentCard.expiryDate', { expiryDate }) }</p>);
    let cardNumber;

    if (mask) {
        cardNumber = pan && `**** **** **** ${ pan.substring(pan.length - 4) }`;
    } else {
        cardNumber = pan && pan.split(/(....)/).join(' ').trim();
    }

    return highDefinition ? (
        <div className={cardClassNames}>
            { highDefImageArt }
            <div className="pan-hd__details">
                {cardNumber}
                {showExpires && cardExpiryDate}
            </div>
        </div>
    ) : (
        <div className={cardClassNames}>
            {cardArtUrl && visaCheckoutCardArt}
            {cardNumber}
            {showExpires && cardExpiryDate}
        </div>
    );
}

PaymentCardDetails.propTypes = {
    card: PropTypes.oneOfType([
        PropTypes.instanceOf(StoredPaymentCard),
        PropTypes.instanceOf(CardPayment),
        PropTypes.instanceOf(HostedCardPayment),
    ]).isRequired,
    className: PropTypes.string,
    highDefinition: PropTypes.bool,
    showExpires: PropTypes.bool,
    mask: PropTypes.bool
};

PaymentCardDetails.defaultProps = {
    className: '',
    showExpires: false,
    mask: true
};

export default PaymentCardDetails;



// WEBPACK FOOTER //
// ./src/components/payment/PaymentCardDetails.js